import { memo, useState } from "react";

import { Errors } from "services/forms/validation/types";

// Tipovi i konstante
import { TireSetSearchFiltersModalProps } from "./types";

// UI komponente
import { Button } from "ui/components/Button/Button";

import { Loader } from "ui/components/Loader";
import { useTranslate } from "helpers";

import VehicleManufacturerDropdown from "ui/components/Dropdown/VehicleManufacturerDropdown/VehicleManufacturerDropdown";
import VehicleModelDropdown from "ui/components/Dropdown/VehicleModelDropdown/VehicleModelDropdown";
import VehicleTypeDropdown from "ui/components/Dropdown/VehicleTypeDropdown/VehicleTypeDropdown";

import {
  useHandleDropdownChange,
  useHandleTextFieldChange,
} from "services/forms/hooks";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { TextField } from "ui/components/TextField/TextField";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";

const TireSetSearchFiltersModal: React.FC<TireSetSearchFiltersModalProps> = (
  props
) => {
  const { show, onSuccess, onClose, formValues, setFormValues } = props;

  const { t } = useTranslate();

  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDropdownChange = useHandleDropdownChange(
    setFormValues,
    formValues,
    formValues.advancedSearch
  );

  const handleTextFieldChange = useHandleTextFieldChange(
    setFormValues,
    formValues,
    formValues.advancedSearch
  );

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      onSuccess(formValues);
    } catch (e) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  const warehouseItems: DropdownOption[] = [
    { text: "Skladište 1", value: "2222-3333-4444-5551" },
    { text: "Skladište 2", value: "2222-3333-4444-5552" },
    { text: "Skladište 3", value: "2222-3333-4444-5553" },
    { text: "Skladište 4", value: "2222-3333-4444-5555" },
  ];

  return (
    <Modal show={show} onHide={onClose} size="small">
      <ModalHeader
        icon="/media/images/search-icon.svg"
        title={t("admin.tire.search.filter.title")}
        onHide={onClose}
      />
      <ModalBody>
      <div className="flex gap-4">
        <div className="w-full m-auto">
          <div className="space-y-3"></div>
          <form noValidate className="text-left">
            <div className="px-5 pt-4 pb-3 mb-2">
              <div>
                <label className="block text-sm mb-2 font-medium leading-6 text-[#344054]">
                  Vozilo
                </label>
                <div className="flex flex-col gap-3 mb-3">
                  <div className="flex-1 ">
                    <VehicleManufacturerDropdown
                      placeholder={t("admin.vehicle.manufacturer.placeholder")}
                      name="vehicleManufacturerId"
                      value={formValues.vehicleManufacturerId}
                      onChange={handleDropdownChange}
                      error={errors.vehicleManufacturerId}
                      required={true}
                    />
                  </div>
                  <div className="flex-1 ">
                    <VehicleModelDropdown
                      vehicleManufacturerId={formValues.vehicleManufacturerId}
                      placeholder={t("admin.vehicle.model.placeholder")}
                      name="vehicleModelId"
                      value={formValues.vehicleModelId}
                      onChange={handleDropdownChange}
                      error={errors.vehicleModelId}
                      disabled={!formValues.vehicleManufacturerId}
                      required={true}
                    />
                  </div>
                  <div className="flex-1 ">
                    <VehicleTypeDropdown
                      vehicleManufacturerId={formValues.vehicleManufacturerId}
                      vehicleModelId={formValues.vehicleModelId}
                      placeholder={t("admin.vehicle.type.placeholder")}
                      name="vehicleTypeId"
                      value={formValues.vehicleTypeId}
                      onChange={handleDropdownChange}
                      error={errors.vehicleTypeId}
                      disabled={!formValues.vehicleModelId}
                      required={true}
                    />
                  </div>
                </div>
              </div>
              <div className="flex gap-3 mb-3">
                <div className="flex-1 ">
                  <Dropdown
                    name="warehouseId"
                    label={t("admin.tire.search.filter.warehouse")}
                    placeholder={t(
                      "admin.tire.search.filter.warehouse.placeholder"
                    )}
                    options={warehouseItems}
                    onChange={handleDropdownChange}
                    value={formValues.warehouseId}
              
                  />
                </div>
              </div>
              <div className="flex gap-3 mb-3">
                <div className="flex-1 ">
                  <TextField
                    type="number"
                    name="dot"
                    label={t("admin.tire.search.filter.dot")}
                    placeholder={t("admin.tire.search.filter.dot.placeholder")}
                    onChange={handleTextFieldChange}
                    error={errors.dot}
                    value={formValues.dot}
                    required
                    groupAppend="MM/YY"
                  ></TextField>
                </div>
                <div className="flex-1 ">
                  <TextField
                    type="number"
                    name="profileDepth"
                    label={t("admin.tire.search.filter.profiledepth")}
                    placeholder={t(
                      "admin.tire.search.filter.profiledepth.placeholder"
                    )}
                    onChange={handleTextFieldChange}
                    error={errors.profileDepth}
                    value={formValues.profileDepth}
                    required
                    groupAppend="cm"
                  ></TextField>
                </div>
              </div>
              <div className="flex gap-3 mb-3"></div>
            </div>
            <div className="px-4 py-3 fixed left-0 bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end gap-3">
              <Button
                variant="outlined"
                children={t("admin.close")}
                onClick={() => onClose()}
              />
              <Button
                variant="primary"
                children={t("admin.search")}
                onClick={handleFormSubmit}
              />
            </div>
          </form>
        </div>
      </div>

      <Loader isLoading={isLoading ?? false}> </Loader>
      </ModalBody>
    </Modal>
  );
};
export default memo(TireSetSearchFiltersModal);
